module.exports = __webpack_public_path__ + "static/media/resume.e3be74ce.pdf";